import CryptoJS from "crypto-js";

export const encrypt = (text) => {
  return CryptoJS.AES.encrypt(
    text,
    process.env.REACT_APP_SECRET_KEY
  ).toString();
};

export const decrypt = (encryptedBase64) => {
  const decrypted = CryptoJS.AES.decrypt(
    encryptedBase64,
    process.env.REACT_APP_SECRET_KEY
  );
  if (decrypted) {
    try {
      const str = decrypted.toString(CryptoJS.enc.Utf8);
      if (str.length > 0) {
        return str;
      } else {
        return "error 1";
      }
    } catch (e) {
      return "error 2";
    }
  }
  return "error 3";
};
